<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <DirPath :path="['Sesión de trabajo']" />
      <HeaderView v-bind="headerData" />

      <div class="row my-5">
        <div class="col-md-12 text-center">
          <router-link
            :to="'/dashboard/analytics/workSession/createWorkGroup'"
            v-slot="{ href, route, navigate, isExactActive }"
          >
            <button
              :href="href"
              @click="navigate"
              :class="[isExactActive && 'text-logo']"
              class="button default"
            >
              Grupos de Trabajo
            </button>
          </router-link>
          <!-- <router-link
            :to="'/dashboard/analytics/workSession/work1To1'"
            v-slot="{ href, route, navigate, isExactActive }"
          >
            <button
              :href="href"
              @click="navigate"
              :class="[isExactActive && 'text-logo']"
              class="button default mx-3"
            >
              Trabajo 1 a 1
            </button>
          </router-link> -->
          <!-- <router-link
            :to="'/dashboard/analytics/workSession/groupWorking'"
            v-slot="{ href, route, navigate, isExactActive }"
          >
            <button
              :href="href"
              @click="navigate"
              :class="[isExactActive && 'text-logo']"
              class="button default mx-3"
            >
              Trabajo Grupal
            </button>
          </router-link> -->
        </div>
      </div>

      <router-view />

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import HeaderView from "@/components/HeaderView";

export default {
  name: "WorkSession",
  components: {
    DirPath,
    FooterComponent,
    HeaderView,
  },
  data() {
    return {
      headerData: {
        title: "Sesión de trabajo",
        subTitle: "",
        body: "Escoge cómo deseas que tus estudiantes trabajen con Beereaders",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.doc {
  width: 6px;
  height: 6px;
  background: #52e100;
  border-radius: 50%;
}

.table-status {
  overflow-x: auto;
}
</style>
